import * as React from 'react'
import { Helmet } from 'react-helmet'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import { useTransition, animated } from 'react-spring'
import { TemperatureUnitProvider } from 'context/TemperatureUnitContext'
// import { FormOpenProvider } from 'context/FormOpenContext'
import { DesktopNav } from './components/DesktopNav'
import { MobileNav } from './components/MobileNav'
import objectFitImages from 'object-fit-images'
import { SelectedMonthProvider } from 'context/SelectedMonthContext'
import { CookieConsent } from 'components/layout/components/CookieConsent'
import { Footer } from './components/Footer'
import { getCookie, setCookie } from 'services/cookies'
import isBrowser from 'services/isBrowser'
import { FaqStructured } from './components/FaqStructured'
import generateStructuredFaqs from 'services/generateStructuredFaqs'

export const Layout = ({ children, title, description, showTemperatureSlider, fadedHeader, switchTitleOrder, path, faqs }: { children: React.ReactNode, title: string, description: string, showTemperatureSlider?: boolean, fadedHeader?: boolean, switchTitleOrder?: boolean, path: string, faqs?: { question: string, answer: string }[] }) => {
    objectFitImages()
    // smoothscroll.polyfill()
    const breakpoints = useBreakpoint()
    const isDesktop = !breakpoints.md
    const isMobile = breakpoints.md
    const [showCookieConsentBar, setShowCookieConsentBar] = React.useState(false)
    React.useEffect(() => {
        setShowCookieConsentBar(isBrowser() && !getCookie('cookie_consent') && path.indexOf('cookie-policy')<0 && path.indexOf('privacy-policy')<0)
        //setShowCookieConsentBar(isBrowser())
    })
    const transitions = useTransition(showCookieConsentBar, {
        from: { opacity: 0 },
        enter: { opacity: 1 },
        leave: { opacity: 0 },
        config: { duration: 200 }
    })
    path = path.endsWith('/') ? path : `${path}/`;
    const url = `https://www.sunheron.com`;
    const completeUrl = `${url}${path}`;
    const titleText = switchTitleOrder ? `Sunheron | ${title}` : `${title} | Sunheron`;
    //console.log(faqs);
    return (
        <div className="application">
            <Helmet>
                <html lang="en" />
                <link
                    rel="shortcut icon"
                    href="/favicon.ico"
                    type="image/x-icon"
                />
                <title>{titleText}</title>
                <meta name="title" content={`${titleText}`} />
                <meta name="description" content={description} />
                <meta name="keywords" content="weather, tourism, season, temperature, sea temperature, wet day, climate, precipitation, rain season, rain, sunhours, wind, humidity" />
                <meta name="robots" content="index, follow" />
                <meta name="language" content="en" />
                <meta name="revisit-after" content="30 days" />
                <meta name="google-site-verification" content="2kiGFT2MiCnfz2Xi33lKz14y67PWEp-Boh8Fz25VK40" />
                <link rel="apple-touch-icon" sizes="57x57" href="https://www.sunheron.com/sunheron-touch-icon-57x57.png" />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={completeUrl} />
                <meta property="og:title" content={title} />
                <meta property="og:description" content={description} />
                <meta property="og:image" content={`${url}/sunheron-og.png`} />
                <meta property="twitter:card" content="summary_large_image" />
                <meta property="twitter:url" content={completeUrl} />
                <meta property="twitter:title" content={title} />
                <meta property="twitter:description" content={description} />
                <meta property="twitter:image" content={`${url}/sunheron-og.png`} />
                {faqs && <script type="application/ld+json">{generateStructuredFaqs(faqs)}</script>}
            </Helmet>
            <SelectedMonthProvider>
                <TemperatureUnitProvider>
                    {/* <FormOpenProvider> */}
                    {isDesktop && <DesktopNav showTemperatureSlider={showTemperatureSlider} fadedHeader={fadedHeader} />}
                    {isMobile && <MobileNav />}
                    <div className="main">{children}</div>
                    {showCookieConsentBar && <CookieConsent
                        onAccept={() => { setCookie({ name: 'cookie_consent', value: 1 }); setShowCookieConsentBar(false); }}
                        onDecline={() => { setCookie({ name: 'cookie_consent', value: 2 }); setShowCookieConsentBar(false); }} />
                    }
                    <Footer></Footer>
                    {/* </FormOpenProvider> */}
                </TemperatureUnitProvider>
            </SelectedMonthProvider>

        </div>

    )
}

